import { tns } from '../translationNamespace'
import { faHouse, faBuilding } from '@fortawesome/pro-solid-svg-icons'
import { ResidentialSubType, ResidentialType } from '@unreserved-frontend-v2/api/generated/graphql/types'
import { HouseIcon } from '@unreserved-frontend-v2/ui/icons/house'
import { CondoIcon } from '@unreserved-frontend-v2/ui/icons/condo'

// TODO:  Set icon/svgIcon in useFilterValuesMobile so that this file is only for enums as it will be auto
//        generated in the future.
//        https://github.com/UnreservedInc/unreserved-frontend-v2/pull/220/files#r987959738
export const RESIDENTIAL_TYPE = [
  { label: tns + ':house', value: ResidentialType.House, icon: faHouse, svgIcon: HouseIcon },
  { label: tns + ':apartment', value: ResidentialType.Apartment, icon: faBuilding, svgIcon: CondoIcon },
]

// TODO: No known values for `Loft`, `Penthouse` currently
export const RESIDENTIAL_SUB_TYPE = [
  {
    label: tns + ':single-house',
    value: ResidentialSubType.Detached,
  },
  {
    label: tns + ':townhouse',
    value: ResidentialSubType.Townhouse,
  },
  {
    label: tns + ':semi-detached-house',
    value: ResidentialSubType.SemiDetached,
  },
  {
    label: tns + ':high-rise-condo',
    value: ResidentialSubType.HighRise,
  },
  {
    label: tns + ':low-rise-condo',
    value: ResidentialSubType.LowRise,
  },
  {
    label: tns + ':multiplex',
    value: ResidentialSubType.MultiFamilyHouse,
  },
  {
    label: tns + ':other',
    value: ResidentialSubType.Unknown,
  },
]

export const RESIDENTIAL_TYPE_LABELS: Record<ResidentialType, string> = RESIDENTIAL_TYPE.reduce(
  (memo, item) => ({ ...memo, [item.value]: item.label }),
  {} as Record<ResidentialType, string>
)
